/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Tlm_3Inputs */

const en_svc_retainer_tlm_3 = /** @type {(inputs: Svc_Retainer_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`reporting`)
};

const ar_svc_retainer_tlm_3 = /** @type {(inputs: Svc_Retainer_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التقارير`)
};

const bn_svc_retainer_tlm_3 = /** @type {(inputs: Svc_Retainer_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিপোর্টিং`)
};

const de_svc_retainer_tlm_3 = /** @type {(inputs: Svc_Retainer_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berichterstattung`)
};

const es_svc_retainer_tlm_3 = /** @type {(inputs: Svc_Retainer_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informes`)
};

const fr_svc_retainer_tlm_3 = /** @type {(inputs: Svc_Retainer_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapports`)
};

const pt_svc_retainer_tlm_3 = /** @type {(inputs: Svc_Retainer_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relatórios`)
};

const zh_svc_retainer_tlm_3 = /** @type {(inputs: Svc_Retainer_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`汇报`)
};

const tr_svc_retainer_tlm_3 = /** @type {(inputs: Svc_Retainer_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raporlama`)
};

const ru_svc_retainer_tlm_3 = /** @type {(inputs: Svc_Retainer_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отчётность`)
};

const pl_svc_retainer_tlm_3 = /** @type {(inputs: Svc_Retainer_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raportowanie`)
};

/**
* | output |
* | --- |
* | "reporting" |
*
* @param {Svc_Retainer_Tlm_3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_retainer_tlm_3 = /** @type {((inputs?: Svc_Retainer_Tlm_3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Tlm_3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_tlm_3(inputs)
	if (locale === "bn") return bn_svc_retainer_tlm_3(inputs)
	if (locale === "de") return de_svc_retainer_tlm_3(inputs)
	if (locale === "es") return es_svc_retainer_tlm_3(inputs)
	if (locale === "fr") return fr_svc_retainer_tlm_3(inputs)
	if (locale === "pt") return pt_svc_retainer_tlm_3(inputs)
	if (locale === "zh") return zh_svc_retainer_tlm_3(inputs)
	if (locale === "tr") return tr_svc_retainer_tlm_3(inputs)
	if (locale === "ru") return ru_svc_retainer_tlm_3(inputs)
	if (locale === "pl") return pl_svc_retainer_tlm_3(inputs)
	return en_svc_retainer_tlm_3(inputs)
});